import { render, staticRenderFns } from "./CoursewareClipboardItem.vue?vue&type=template&id=34f0d9ca&"
import script from "./CoursewareClipboardItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareClipboardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports